import { render, staticRenderFns } from "./MasterMain.vue?vue&type=template&id=5c806d54"
import script from "./MasterMain.vue?vue&type=script&lang=js"
export * from "./MasterMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports